export const EMPTY_DOLLAR = {
    value: "",
    uom: { value: 190056, text: "$", code: null, tagMaskValue: 1 },
};

export const EMPTY_YEAR = {
    value: "",
    uom: { value: 190070, text: "years", code: null, tagMaskValue: 48 },
};
